module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Chaise_Cloud.8a8c92da.png";